import '../../../../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/globals';

(function($, window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const referenceList = $('.custom-reference-list');

        if ($(referenceList).length > 0) {
            let identifier,
                showCards,
                currentPage,
                loadMoreButton,
                currentCount,
                count;
            const loadingButtons = $('.custom-reference-list__show-more');

            /**
             * Load next references
             *
             * @param listIdentifier
             * @param listCurrentPage
             * @param listShowCards
             * @param referenceList
             */
            function getCustomReferenceListData(listIdentifier, listCurrentPage, listShowCards, referenceList) {
                $.ajax({
                    method: 'GET',
                    url: _AVENCY_BASE_actions.customReferenceList,
                    data: {
                        showCards: listShowCards,
                        currentPage: listCurrentPage,
                        identifier: listIdentifier
                    }
                }).done(function (data) {
                    $(referenceList).append(data);
                });
            }

            if ($(loadingButtons).length > 0) {
                $(loadingButtons).each(function () {
                    $(this).on('click', function () {
                        const referenceList = $(this).closest('.custom-reference-list-wrapper').find('.custom-reference-list');

                        identifier = $(referenceList).data('identifier');
                        showCards = $(referenceList).data('showcards');
                        currentPage = $(referenceList).data('currentpage') + 1;
                        $(referenceList).data('currentpage', currentPage);

                        count = $(referenceList).find('div[data-count]:first').data('count');
                        currentCount = currentPage * showCards;

                        getCustomReferenceListData(identifier, currentPage, showCards, referenceList);

                        if (currentCount >= count) {
                            $(this).addClass('d-none');
                        } else {
                            $(this).removeClass('d-none');
                        }
                    });
                });
            }
            $(referenceList).each(function () {
                identifier = $(this).data('identifier');
                showCards = $(this).data('showcards');
                loadMoreButton = $('#custom-reference-list_' + identifier + ' .custom-reference-list__show-more');
                count = $('#custom-reference-list_' + identifier + ' .custom-reference-list div[data-count]:first').data('count');

                if (showCards >= count) {
                    loadMoreButton.addClass('d-none');
                } else {
                    loadMoreButton.removeClass('d-none');
                }
            });
        }
    });
})(jQuery, window, window.PageLoadedQueue);
